import { useSyncExternalStore } from 'react'
import { pubSubGrid } from '../../state/pubSub'
import { getGridStateSelector } from '../../state/state.grid'

const subGrid = (callback) => pubSubGrid.on('state', callback)
const getAvatarInfoOpen = (id: number) => () =>
    getGridStateSelector('avatarInfoOpenID') === id

export const useGridAvatarInfoOpenAppState = (id: number): boolean => {
    return useSyncExternalStore(
        subGrid,
        getAvatarInfoOpen(id),
        getAvatarInfoOpen(id),
    )
}
